import axios, { AxiosResponse } from 'axios';
import { store } from '../../index';
import * as AppData from '../../store/AppData';

export default class Helpers {

    static sendUserDataWhenErrorOccurs = () => {
        try {
            let applicationData = store.getState().appData.app4legalData ? store.getState().appData.app4legalData : store.getState().appData.contractData;
            if (applicationData) {
                return {
                    'api-base-url': store.getState().appData.app4legalData["api-base-url"],
                    'module': applicationData['module'],
                    'module-record-id': applicationData['module-record-id'],
                    'email': applicationData['email'],
                    'exception':""
                };
            } else {
                return null;
            }
        } catch (e) {
            return null;
        }
    };

    static saveLogs = async (logs:any) => {
        try {
            let objectForm = Helpers.sendUserDataWhenErrorOccurs()
            if (objectForm !== null) {
                objectForm.exception = logs;
            } else {
                objectForm = logs;
            }
            let rLogs = btoa(JSON.stringify(objectForm));
            await axios.post('api/zoom/logger', rLogs, {
                headers: {
                    "content-type": "application/json"
                }
            });
        } catch (e) {

        }
    };
    static post = async (api: any, dataToPost: any): Promise<AxiosResponse> => {
        let applicationData = store.getState().appData.app4legalData;
        let response = await axios.post(api, dataToPost, {
            headers: {
                "content-type": "application/x-www-form-urlencoded",
                "x-api-key": applicationData["x-api-key"],
                "x-api-channel": "zoom-connect"
            }
        });
            return response;

    }
    static deleteZoomTokens = async () => {
      /*  try {*/
            let applicationData = store.getState().appData.app4legalData;
            if (applicationData) {
                let params = new URLSearchParams();
                params.append("integration", "zoom");
                let api = applicationData["api-base-url"] + "modules/api/user_integrations/revoke_access";
                let response = await axios.post(api, params, {
                    headers: {
                        "content-type": "application/x-www-form-urlencoded",
                        "x-api-key": applicationData["x-api-key"],
                        "x-api-channel": "zoom-connect"
                    }
                }).catch(error => {
                    Helpers.saveLogs(error);

                });
            }
        //} catch (e) {

        //}
        //store.dispatch(AppData.actionCreators.fillRefreshTokenData(""));
        //store.dispatch(AppData.actionCreators.fillAccessTokenData(""));
        store.dispatch(AppData.actionCreators.fillTokens(""));

    };
    static getZoomTokens = async (applicationData:any) => {
        try {
            if (applicationData) {
                let params = new URLSearchParams();
                params.append("integration", "zoom");
                let api = applicationData["api-base-url"] + "modules/api/user_integrations/get";
                let response = await Helpers.post(api, params).catch(error => {
                    Helpers.saveLogs(error);
                });
                return response;
            }
        } catch (e) {

        }
    };
    static setZoomTokens = async (baseUrl: any,data:any) => {
        try {
            if (baseUrl) {
                let params = new URLSearchParams();
                params.append("integration", "zoom");
                params.append("tokens", data);
                let api = baseUrl + "modules/api/user_integrations/set";
                let response = await Helpers.post(api, params).catch(error => {
                    Helpers.saveLogs(error);
                });
                return response;
            }
        } catch (e) {

        }
    };
    static ValidateEmail(inputText:any) {
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(inputText)) {
            return (true)
        }
        return (false)
    };

    static revokeZoomToken = async (data: any) => {
        try {

            await axios.post('api/zoom/revoke', data, {
                headers: {
                    "content-type": "application/json",
                    "x-api-channel": "zoom-connect"
                }
            });
        } catch (e) {

        }
    };

};
